import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Button } from "@mui/material";
import { Download } from "@mui/icons-material";
import { useAuthContext } from "../context/AuthContext";

const DownloadButton = ({ downloadUrl, filename, buttonText, disabled }) => {
  const { loading, setLoading } = useAuthContext();
  const fetchDataDownload = async () => {
    try {
      setLoading(true);

      const response = await axios.get(downloadUrl, {
        responseType: "blob",
        withCredentials: true,
      });

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      saveAs(blob, filename);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      onClick={fetchDataDownload}
      disabled={disabled || loading}
      style={{
        marginRight: 8,
        backgroundColor: "#1976D2",
        color: "#FFF",
      }}
      startIcon={<Download />}
    >
      {buttonText}
    </Button>
  );
};

export default DownloadButton;
